<template>
  <div>
    <a-modal title="" width="60rem" :visible="visible" :confirm-loading="confirmLoading" @cancel="handleCancel">
      <div class="bigbox">
        <div class="box">
          <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="渠道选择">
              <div style="display: flex">
                <div class="list">
                  <p>渠道列表</p>
                  <ul>
                    <li v-for="(item,i) in list" :key="i" @click="fn(i,item)"
                      :style="num==i ?'background: linear-gradient(133deg, #106AFF 0%, #106AFF 12%, #0F53C3 100%);color:#fff':'' ">
                      <!-- <img src="../../assets/channel/3.png" alt=""> -->
                      <img :width="num==i ?'30':'22'" style="margin-left:10px" :src=" num==i ? meitiimg[i]:meitiimgs[i]"
                        alt=""> {{item.name}}
                    </li>
                  </ul>
                </div>
                <!-- <div class="list1" v-if="media">
                  <p>媒体列表</p>
                  <ul>
                    <li v-for="(item,i) in 8" :key="i">
                      <img width="50" height="50" :src="listimg[i]" alt="" style="margin-right:20px;margin-left:10px;">
                      <p style="display:flex;flex-direction: column;padding-top:10px">
                        <span>微信号</span>
                        <span
                          style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #999999;">江苏体育讲堂</span>
                      </p>
                    </li>
                  </ul>
                </div> -->
                <div class="list2">
                  <tree res="tree" :checkedKeys="cwSaveCheck" :checkedKeysC="cwSaveCheckC" @sitenameC="sitenameC"
                    @sitenamenumC="sitenamenumC" @sitename="sitename" @sitenamenum="sitenamenum" :selectid="selectid" />
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="box1">
          <div class="peoples">
            <div class="back">
              <p>送审人</p>
              <div>
                <a-select v-model="selsecinfo" placeholder="请选择送审人" style="width: 120px" @change="handleChange">
                  <a-select-option v-for="(item,i) in listinfo" :key="i" :value="item.id">
                    {{item.likeName}}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <p style="margin-top:20px;margin-left:20px">发布站点</p>
            <div class="ulli" style="margin-left:20px" v-if='!media'>
              <ul>
                <li v-for="(item,i) in listobj" :key="i">
                  <div class="lispan">
                    <span>{{item.name}}</span>
                    <a-badge :count="item.column==null ? 0:item.column.length" :number-style="{
                        backgroundColor: '#106AFF',
                        color: '#FFFFFF',
                        marginLeft:'10px'
                     }" />
                    <a-badge :count="item.specialcolumn==null ? 0:item.specialcolumn.length" :number-style="{
                        backgroundColor: '#FB8D03',
                        color: '#FFFFFF',
                        marginLeft:'10px'
                     }" />
                  </div>
                  <div style="display: flex;flex-wrap: wrap;align-items: center;">
                    <span v-for="(items,j) in item.column" :key="j" style="margin-right:10px" class="spn">
                      {{items.name}}
                    </span>
                  </div>
                  <div style="display: flex;flex-wrap: wrap;align-items: center;">
                    <span v-for="(items,j) in item.specialcolumn" :key="j" style="margin-right:10px" class="spnc">
                      {{items.name}}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
      <div style="height:53px;width:40.1%;border-left:1px solid #ECECEC;float:right;display: flex;
     justify-content: flex-end;
     align-items: center; ">
        <a-button style="margin-right:20px;z-index:999" @click="cancel">取消</a-button>
        <a-button style="margin-right:20px;z-index:999" type="primary" @click="examine">
          提交审核
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
  import tree from './tree/index.vue'
  import {
    selectAccountList,
    createArticle,
    createAtlas,
    createLink,
    createVideo,
    articleSourceUpdateArticle,
    atlasSource,
    updateVideo,
    list,
    updateLink
  } from "@/api/content";
  export default {
    props: {
      dialogVisible: {
        type: Boolean,
        required: true,
      },
      paramlist: {
        type: Object
      },
      atlaslist: {
        type: Object
      },
      chainlist: {
        type: Object
      },
      editorType: {
        type: String
      },
      content: {
        type: String
      },
      videoimglist: {
        type: Object
      },
    },
    components: {
      tree
    },
    filters: {
      filterst: function (val) {
        console.log(val);
        if (val) {

        }
      }
    },
    watch: {
      dialogVisible() {
        this.visible = this.dialogVisible;
      },
      checkedKeys(val) {
        console.log('onCheck', val);
      },
    },
    data() {
      return {
        checkedKeys: [], //选中key
        checkedKeysC: [], //选中key
        listimg: [require('../../assets/components/toutiao.png'),
          require('../../assets/components/weixin.png'),
          require('../../assets/components/wangyi.png'),
          require('../../assets/components/qutou.png'),
          require('../../assets/components/yu.png'),
          require('../../assets/components/bai.png'),
          require('../../assets/components/dou.png'),
          require('../../assets/components/feng.png'),
        ],
        meitiimg: [require('../../assets/components/zimei.png'),
          require('../../assets/components/形状@2x.png'),
          require('../../assets/components/1.png'),
          require('../../assets/components/1.png'),
          require('../../assets/components/1.png'),
          require('../../assets/components/12.png'),
          require('../../assets/components/12.png'),
          require('../../assets/components/12.png'),
        ],
        meitiimgs: [require('../../assets/channel/3.png'),
          require('../../assets/channel/4.png'),
          require('../../assets/channel/5.png'),
          require('../../assets/channel/6.png'),
          require('../../assets/channel/6.png'),
          require('../../assets/channel/7.png'),
          require('../../assets/channel/7.png'),
          require('../../assets/channel/7.png'),
        ],
        num: -1,
        selsecinfo: 2, //送稿人id
        media: true,
        visible: false,
        confirmLoading: false,
        list: [],
        listinfo: [],
        expandedKeys: ['0-0-0', '0-0-1'],
        autoExpandParent: true,
        selectedKeys: [],
        selectid: '',
        listset: [],
        labelname: [],
        publishChannelColumn: [],
        listobj: [],
        columnid: '',

        cwSaveCheck: [],
        cwSaveCheckC: [],
      };
    },
    methods: {
      sitename(val, data) {

        // this.listobj = JSON.parse(JSON.stringify(this.list))
        if (val.length > 0) {
          for (let i = 0; i < this.listobj.length; i++) {
            if (this.num == i) {
              this.listobj[i].column = val
              this.$forceUpdate()
            }
          }
        } else {
          for (let i = 0; i < this.listobj.length; i++) {
            if (this.num == i) {
              this.listobj[i].column = []
              this.$forceUpdate()
            }
          }
        }

        let cwData = Array.from(new Set(data))
        this.cwSaveCheck = cwData
      },
      sitenamenum(val) {
        this.columnid = val.join(',')
      },
      sitenameC(val, data, arr) {
        let arrs = Array.from(new Set(arr));
        if (val.length > 0) {
          for (let i = 0; i < this.listobj.length; i++) {
            if (this.num == i) {
              this.listobj[i].specialcolumn = val
              this.listobj[i].specialid = arrs
              this.$forceUpdate()
            }
          }
        } else {
          for (let i = 0; i < this.listobj.length; i++) {
            if (this.num == i) {
              this.listobj[i].specialcolumn = []
              this.listobj[i].specialid = []
              this.$forceUpdate()
            }
          }
        }
        let cwData = Array.from(new Set(data))
        console.log(this.listobj);
        this.cwSaveCheckC = cwData
        console.log(this.cwSaveCheckC);
      },
      sitenamenumC(val) {
        this.columnidC = val.join(',')
      },
      examine() {
        for (let i = 0; i < this.listobj.length; i++) {
          if (this.listobj[i].hasOwnProperty('column')) {
            let columnArr = this.listobj[i].column
            this.listobj[i].columnid = []
            for (let j = 0; j < columnArr.length; j++) {
              this.listobj[i].columnid.push(columnArr[j].key)
            }
          }
        }
        for (let i = 0; i < this.listobj.length; i++) {
          if (this.listobj[i].hasOwnProperty('column')) {
            let columnArr = this.listobj[i].specialcolumn
            this.listobj[i].specialId = []
            for (let j = 0; j < columnArr.length; j++) {
              this.listobj[i].specialId.push(columnArr[j].key)
            }
          }
        }
        let publishChannelColumn = []
        for (let i = 0; i < this.listobj.length; i++) {
          if (this.listobj[i].hasOwnProperty('columnid')) {
            publishChannelColumn.push({
              channel: this.listobj[i].id,
              channelClass: 1,
              column: this.listobj[i].columnid.join(','),
              specialColumn: JSON.stringify([{
                specialId: this.listobj[i].specialid.join(','),
                column: this.listobj[i].specialId.join(','),
              }])
            })
          }
        }

        if (this.editorType == '1') {
          if (this.selsecinfo != '') {
            this.paramlist.auditorUid = this.selsecinfo
            let params = this.paramlist
            if (sessionStorage.getItem("manuscript")) {
              delete params.createInternalUid;
              let arr = JSON.parse(sessionStorage.getItem("manuscript"))
              params.id = arr.id
              params.lastUpdateInternalUid = JSON.parse(localStorage.getItem("userinfo")).userModel.id
              console.log(publishChannelColumn);
               articleSourceUpdateArticle(encodeURIComponent(JSON.stringify(publishChannelColumn)), params).then(
                  res => {
                    if (res.status) {
                      this.$message.success(res.message);
                      sessionStorage.removeItem("manuscript")
                      this.$router.push('my')
                    }
                  })
            } else {
              createArticle(encodeURIComponent(JSON.stringify(publishChannelColumn)), params).then(res => {
                if (res.status) {
                  this.$message.success(res.message);
                  this.$router.push('my')
                  this.visible = false
                  this.$emit("dialog", false)
                }
              })
            }

          } else {
            this.$message.error("请选择审核人");
          }
        }
        if (this.editorType == '2') {
          if (this.selsecinfo != '') {
            this.atlaslist.auditorUid = this.selsecinfo
            let params = this.atlaslist
            // console.log(params);
            // let publishChannelColumn = [{
            //   channel: this.selectid,
            //   channelClass: 1,
            //   column: this.columnid
            // }]
            let params2 = encodeURIComponent(JSON.stringify(this.content))
            let params1 = encodeURIComponent(JSON.stringify(publishChannelColumn))
            if (sessionStorage.getItem("manuscript")) {
              delete params.createInternalUid;
              let arr = JSON.parse(sessionStorage.getItem("manuscript"))
              params.id = arr.id
              params.lastUpdateInternalUid = JSON.parse(localStorage.getItem("userinfo")).userModel.id,
                atlasSource(params1, params2, params).then(res => {
                  if (res.status) {
                    this.$message.success(res.message);
                    sessionStorage.removeItem("manuscript")
                    this.$router.push('my')
                  }
                })
            } else {
              createAtlas(params1, params2, params).then(res => {
                if (res.status) {
                  this.$message.success(res.message);
                  this.$router.push('my')
                  this.visible = false
                  this.$emit("dialog", false)
                }
              })
            }


          } else {
            this.$message.error("请选择审核人");
          }
        }
        if (this.editorType == '3') {
          if (this.selsecinfo != '') {
            this.videoimglist.auditorUid = this.selsecinfo
            let params = this.videoimglist
            // let publishChannelColumn = [{
            //   channel: this.selectid,
            //   channelClass: 1,
            //   column: this.columnid
            // }]
            if (sessionStorage.getItem("manuscript")) {
              let arr = JSON.parse(sessionStorage.getItem("manuscript"))
              delete params.createInternalUid;
              params.id = arr.id
              params.lastUpdateInternalUid = JSON.parse(localStorage.getItem("userinfo")).userModel.id,
                updateVideo(encodeURIComponent(JSON.stringify(publishChannelColumn)), params).then(res => {
                  if (res.status) {
                    this.$message.success(res.message);
                    sessionStorage.removeItem("manuscript")
                    this.$router.push('draft')
                  }
                })
            } else {
              createVideo(encodeURIComponent(JSON.stringify(publishChannelColumn)), params).then(res => {
                if (res.status) {
                  this.$message.success(res.message);
                  this.$router.push('my')
                  this.visible = false
                  this.$emit("dialog", false)
                }
              })
            }
          } else {
            this.$message.error("请选择审核人");
          }
        }
        if (this.editorType == '4') {
          if (this.selsecinfo != '') {
            this.chainlist.auditorUid = this.selsecinfo
            let params = this.chainlist
            // let publishChannelColumn = [{
            //   channel: this.selectid,
            //   channelClass: 1,
            //   column: this.columnid
            // }]
            if (sessionStorage.getItem("manuscript")) {
              delete params.createInternalUid;
              let arr = JSON.parse(sessionStorage.getItem("manuscript"))
              params.id = arr.id
              params.lastUpdateInternalUid = JSON.parse(localStorage.getItem("userinfo")).userModel.id,
                updateLink(encodeURIComponent(JSON.stringify(publishChannelColumn)), params).then(
                  res => {
                    if (res.status) {
                      this.$message.success(res.message);
                      sessionStorage.removeItem("manuscript")
                      this.$router.push('my')
                    }
                  })
            } else {
              createLink(encodeURIComponent(JSON.stringify(publishChannelColumn)), params).then(res => {
                if (res.status) {
                  this.$message.success(res.message);
                  this.$router.push('my')
                  this.visible = false
                  this.$emit("dialog", false)
                }
              })
            }

          } else {
            this.$message.error("请选择审核人");
          }
        }

      },
      cancel() {
        this.visible = false
        this.$emit("dialog", false)
      },
      listapi() {
        let params = {
          pageSize: 90
        }
        list(params).then(res => {
          this.listinfo = res.data
          this.listset = res.data
        })
      },
      selectAccountListapi() {
        let params = {
          channelClass: 1,
          pageSize: 999
        }
        selectAccountList(params).then(res => {
          this.list.push(...res.data)
        })
      },
      handleChange() {
        console.log(this.selsecinfo);
      },
      callback(key) {
        console.log(key);
      },
      handleCancel() {
        this.$emit("update:dialogVisible", false);
      },
      fn(val, item) {
        if (item.name == "自媒体渠道") {

        } else {
          console.log('渠道点击', val, item);
          this.media = false
          this.selectid = item.id
          console.log(this.num);
          if (this.num == -1) {
            this.listobj = JSON.parse(JSON.stringify(this.list))
          }

        }
        this.num = val
      },
      onSearch(value) {
        console.log(value);
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys);
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      onCheck(checkedKeys) {
        console.log('onCheck', checkedKeys);
        this.checkedKeys = checkedKeys;
      },
      onSelect(selectedKeys, info) {
        console.log('onSelect', info);
        this.selectedKeys = selectedKeys;
      },
    },
    mounted() {
      // this.selectAccountListapi()
      // this.listapi()
    },
  };
</script>

<style scoped lang="scss">
  /deep/.ant-modal-header {
    border-bottom: 0;
  }

  /deep/.ant-modal-footer {
    border-top: 1px solid white;
  }

  /deep/.ant-modal-body {
    padding: 0;
  }

  /deep/.ant-tabs-bar {
    margin: 0;
  }

  .bigbox {
    display: flex;
    height: 400px;
  }

  .box {
    width: 60%;
    height: 100%;
    border-right: 1px solid#ECECEC;

    .list {
      padding-top: 20px;
      width: 52%;
      height: 356px;
      overflow: auto;
      border-right: 1px solid #ECECEC;
      border-bottom: 1px solid #ECECEC;

      ul {
        padding-left: 20px;
        width: 95%;
        padding-top: 10px;

        li {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          padding: 10px 0;
        }
      }
    }

    .list1 {
      width: 100%;
      padding-top: 20px;
      padding-left: 20px;
      border-bottom: 1px solid #ECECEC;
      height: 356px;

      p {
        padding: 0;
      }

      ul {
        width: 100%;
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
      }

      li {
        width: 47%;
        display: flex;
        align-items: center;
        height: 60px;
        border: 1px solid #ECECEC;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }

    .list2 {
      width: 100%;
      padding-right: 10px;
      padding-left: 10px;
      padding-top: 14px;
      height: 356px;
      overflow: auto;
      border-bottom: 1px solid #ECECEC;
      // /deep/.ant-tree-child-tree {
      //   display: flex;
      //   align-items: center;
      // }
    }

    p {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      padding-left: 14px;
    }


  }

  .box1 {
    width: 40%;
    height: 100%;
    overflow: auto;
    border-right: 1px solid#ECECEC;
    border-bottom: 1px solid#ECECEC;

    .peoples {
      .back {
        background: url('../../assets/components/2.png');
        background-repeat: no-repeat;
        padding-left: 20px;
        padding-top: 20px;
        background-size: cover;
      }

      p {
        margin-bottom: 18px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .ulli {
        li {
          margin-bottom: 10px;

          .ant-tag-has-color {
            color: rgba(16, 106, 255, 0.8);
            padding: 5px;
          }

          /deep/.anticon-close {
            color: rgba(16, 106, 255, 0.8) !important;
          }

          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;


          }

          .spn {
            padding: 5px 10px;
            background: #EDF4FF;
            margin-bottom: 10px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(16, 106, 255, 0.8);
          }

          .spnc {
            padding: 5px 10px;
            background: #FFF6ED;
            margin-bottom: 10px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FB8D03;
          }

          .lispan {
            background: #F6F7FB;
            padding: 5px 10px;
            margin-right: 20px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  /deep/.ant-modal-footer {
    opacity: 0;
  }
</style>